// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B4tFn{background:linear-gradient(297.2deg, #F0EFFA 16.5%, #FCFCFF 100%)}.YXYUg{width:615px;display:flex;flex-direction:column;align-items:center}.ByELD{text-align:center;width:506px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `B4tFn`,
	"container": `YXYUg`,
	"text": `ByELD`
};
export default ___CSS_LOADER_EXPORT___;
